export default __webpack_public_path__ + "static/media/po_number.3357ee2e.png";